import React, { useState } from "react";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css"; // Optional: Theme for JSONPretty
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
const PersonSchemaForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    pictureUrl: "",
    url: "",
    jobTitle: "",
    company: "",
    socialProfiles: [],
  });

 const [schema, setSchema] = useState({
     "@context": "https://schema.org",
  "@type": "Person",
  "name": "",
  "url": "",
  "image": "",
  "jobTitle": "",
  "worksFor": {
    "@type": "Organization",
    "name": ""
  },
  "sameAs": []

  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const addSocialProfile = () => {
    setFormData({
      ...formData,
      socialProfiles: [...formData.socialProfiles, ""],
    });
  };



  const handleSocialProfileChange = (index, value) => {
    const updatedProfiles = formData.socialProfiles.map((profile, i) =>
      i === index ? value : profile
    );
    setFormData({ ...formData, socialProfiles: updatedProfiles });
  };

  const removeSocialProfile = (index) => {
    setFormData({
      ...formData,
      socialProfiles: formData.socialProfiles.filter((_, i) => i !== index),
    });
  };

  const generateSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": "Person",
      name: formData.name,
      url: formData.url,
      image: formData.pictureUrl,
      jobTitle: formData.jobTitle,
      worksFor: {
        "@type": "Organization",
        name: formData.company,
      },
      sameAs: formData.socialProfiles,
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const generatedSchema = generateSchema();
    setSchema(generatedSchema);
    toast.success("Schema generated successfully!");
  };

  const copyToClipboard = () => {
    if (schema) {
      navigator.clipboard.writeText(JSON.stringify(schema, null, 2)).then(() => {
        toast.info("JSON-LD copied to clipboard!");
      });
    } else {
      toast.error("Generate the schema first!");
    }
  };
 const deleteSchema = () => {
    setSchema({
      "@context": "https://schema.org",
   "@type": "Person",
   "name": "",
   "url": "",
   "image": "",
   "jobTitle": "",
   "worksFor": {
     "@type": "Organization",
     "name": ""
   },
   "sameAs": []
 
   });
    toast.warning("Schema reset to dummy data!");
  };
  
  return (
    <div className="container mt-4">
      <ToastContainer />

      <div className="row">
        {/* Form Section */}
        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Enter Person Details</h5>
            <form onSubmit={handleSubmit}>
              {/* Name and Picture */}
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter name"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Picture URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="pictureUrl"
                  value={formData.pictureUrl}
                  onChange={handleInputChange}
                  placeholder="Enter picture URL"
                />
              </div>

              {/* URL and Job Information */}
              <div className="mb-3">
                <label className="form-label">URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="url"
                  value={formData.url}
                  onChange={handleInputChange}
                  placeholder="Enter personal URL"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Job Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="jobTitle"
                  value={formData.jobTitle}
                  onChange={handleInputChange}
                  placeholder="Enter job title"
                />
              </div>

              {/* Company */}
              <div className="mb-3">
                <label className="form-label">Company</label>
                <input
                  type="text"
                  className="form-control"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  placeholder="Enter company name"
                />
              </div>

              {/* Social Profiles */}
              <div className="mb-3">
                <label className="form-label">Social Profiles</label>
                {formData.socialProfiles.map((profile, index) => (
                  <div key={index} className="row align-items-end mb-2">
                    <div className="col-md-10">
                      <input
                        type="text"
                        className="form-control"
                        value={profile}
                        onChange={(e) =>
                          handleSocialProfileChange(index, e.target.value)
                        }
                        placeholder="Enter social profile URL"
                      />
                    </div>
                    <div className="col-md-2 text-end">
                      
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeSocialProfile(index)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addSocialProfile}
                >
                  + Add Social Profile
                </button>
              </div>

              {/* Submit Button */}
              <div className="text-center mt-4">
                <button type="submit" className="btn btn-primary w-100">
                  Generate Schema
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* JSON-LD Preview Section */}
        <div className="col-lg-6">

          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Generated JSON-LD</h5>
            <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={copyToClipboard}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
            {schema ? (
              <div className="position-relative">
                <JSONPretty
                  id="json-pretty"
                  data={schema}
                  className="bg-light p-3 rounded border"
                ></JSONPretty>
                
              </div>
            ) : (
              <p className="text-center">No schema generated yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonSchemaForm;
